module.exports = __webpack_public_path__ + "static/media/jumboIcons2.60325ba3.png";